/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import {
  ERROR_UPDATE_CUSTOMER_PREFERENCES,
  disableContactInfoSave
} from 'state/preferences/PreferencesActions';

const FailedUpdatePreferencesLogic = createLogic({
  type: ERROR_UPDATE_CUSTOMER_PREFERENCES,

  // eslint-disable-next-line no-unused-vars
  process({ action }, dispatch, done) {
    // disable save button after failed response
    dispatch(disableContactInfoSave());

    done();
  }
});

export default FailedUpdatePreferencesLogic;
